import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useJobContext } from "../Context/JobContext"; 

const ListJobVacancy = () => {
  const navigate = useNavigate();
  const { jobList, fetchJobList, deleteJob } = useJobContext();

  useEffect(() => {
    fetchJobList(); 
  }, [fetchJobList]);

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this job?")) {
      deleteJob(id); 
    }
  };

  const handleEdit = (id) => {
    navigate(`/dashboard/list-job-vacancy/form/${id}`); 
  };

  return (
    <main className="flex h-screen z-10">
      <section className="flex-1 p-6 ml-[300px] max-md:ml-[250px] h-full overflow-auto max-sm:ml-[50px] max-sm:mt-16">
        <h1 className="text-2xl font-bold text-indigo-700">Job Listing Table</h1>
        <div className="overflow-x-auto mt-6 text-center">
          <div className="relative overflow-x-auto">
          <table className="min-w-full table-auto border-collapse text-sm">
            <thead className="sticky top-0 bg-slate-50">
              <tr>
                <th className="px-3 py-1 border-b">No</th>
                <th className="px-3 py-1 border-b">Title</th>
                <th className="px-3 py-1 border-b">Description</th>
                <th className="px-3 py-1 border-b">Qualification</th>
                <th className="px-3 py-1 border-b">Type</th>
                <th className="px-3 py-1 border-b">Tenure</th>
                <th className="px-3 py-1 border-b">Status</th>
                <th className="px-3 py-1 border-b">Company</th>
                <th className="px-3 py-1 border-b">Logo</th>
                <th className="px-3 py-1 border-b">City</th>
                <th className="px-3 py-1 border-b">Salary</th>
                <th className="px-3 py-1 border-b">Action</th>
              </tr>
            </thead>
            <tbody>
              {jobList.map((job, index) => (
                <tr key={job._id}>
                  <td className="px-3 py-1 border-b">{index + 1}</td>
                  <td className="px-3 py-1 border-b font-semibold">{job.title}</td>
                  <td className="px-3 py-1 border-b">{job.job_description}</td>
                  <td className="px-3 py-1 border-b">{job.job_qualification}</td>
                  <td className="px-3 py-1 border-b">{job.job_type}</td>
                  <td className="px-3 py-1 border-b">{job.job_tenure}</td>
                  <td className="px-3 py-1 border-b">{job.job_status === 1 ? "Active" : "Inactive"}</td>
                  <td className="px-3 py-1 border-b">{job.company_name}</td>
                  <td className="px-3 py-1 border-b">
                    <img src={job.company_image_url} alt={job.company_name} className="h-10 w-10 object-contain" />
                  </td>
                  <td className="px-3 py-1 border-b">{job.company_city}</td>
                  <td className="px-3 py-1 border-b">
                    {job.salary_min} - {job.salary_max}
                  </td>
                  <td className="px-3 py-1 border-b">
                    <button
                      onClick={() => handleEdit(job._id)} 
                      className="px-3 py-1 bg-blue-500 text-white rounded text-xs mb-2 hover:bg-blue-700 transition duration-300"
                    >
                      Edit
                    </button>
                    <button
                      onClick={() => handleDelete(job._id)} 
                      className="px-3 py-1 bg-red-500 text-white rounded text-xs hover:bg-red-700 transition duration-300"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>
        </div>
      </section>
    </main>
  );
};

export default ListJobVacancy;
